module.exports = __webpack_public_path__ + "img/11_u.ca18d136.jpg";